import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ViewContainerRef,
  ComponentRef,
} from '@angular/core';
import { RegisterIconsService } from 'src/app/services/register-icons.service';
import { MenusService } from 'src/app/services/menus.service';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { ApiS3Service } from 'src/app/services/api-s3.service';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { ShowIfAuthorizedDirective } from 'src/app/directives/show-if-authorized/show-if-authorized.directive';
import { MatMenuModule, MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { CotacoesRamoComponent } from './filtros/cotacoes-ramo/cotacoes-ramo.component';
import { ClientesComponent } from './filtros/clientes/clientes.component';
import { ConfigSeguradorasComponent } from './filtros/config-seguradoras/config-seguradoras.component';
import { ConfigUsuariosComponent } from './filtros/config-usuarios/config-usuarios.component';
import { CorretorasFiltroComponent } from './filtros/corretoras-filtro/corretoras-filtro.component';
import { DashboardComponent } from './filtros/dashboard/dashboard.component';
import { DocumentosComponent } from './filtros/documentos/documentos.component';
import { ListaNegociosComponent } from './filtros/lista-negocios/lista-negocios.component';
import { NegociosComponent } from './filtros/negocios/negocios.component';
import { FiltroParcelasComponent } from './filtros/parcelas/parcelas.component';
import { RamosComponent } from './filtros/ramos/ramos.component';
import { ResultadosComponent } from './filtros/resultados/resultados.component';
import { MatDivider } from '@angular/material/divider';
import { TasksFiltersComponent } from './filtros/tasks/tasks.component';

@Component({
  template: `<div>teste</div>`,
  selector: 'test',
})
class ComponentTest {}

@Component({
  selector: 'filtro',
  templateUrl: './filtro.component.html',
  styleUrls: ['./filtro.component.scss'],
  imports: [CommonModule, MatMenuModule, MatDivider],
})
export class FiltroComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenuTrigger, { static: true }) private trigger!: MatMenuTrigger;

  @ViewChild(MatMenuTrigger, { read: ElementRef })
  triggerButton!: ElementRef<HTMLButtonElement>;

  @ViewChild('filtro', { static: true, read: MatMenu }) menu: MatMenu;

  @ViewChild(ShowIfAuthorizedDirective)
  showIfAuthorizedDirective: ShowIfAuthorizedDirective;

  @ViewChild('container', { read: ViewContainerRef })
  container!: ViewContainerRef;

  private componentRef: any;

  teste = ComponentTest;

  page: string;
  data: any;
  private filtersService!: unknown;

  numFilter = 0;
  listaUsuarios: any = {};
  showTodasCotacoes: boolean = false;

  private activeListener = false;

  protected readonly componentMap = {
    cotacoes: CotacoesRamoComponent,
    dashboard: DashboardComponent,
    clientes: ClientesComponent,
    tarefas: TasksFiltersComponent,
    corretoras: CorretorasFiltroComponent,
    ramos: RamosComponent,
    documetos: DocumentosComponent,
    parcelas: FiltroParcelasComponent,
    'lista-negocios': ListaNegociosComponent,
    negocios: NegociosComponent,
    'config-usuarios': ConfigUsuariosComponent,
    resultados: ResultadosComponent,
    'config-seguradoras': ConfigSeguradorasComponent,
  };

  constructor(
    private menusService: MenusService,
    private icons: RegisterIconsService,
    private apiUsuario: ApiUsuarioService,
    private apiS3: ApiS3Service,
    public filtroController: FiltroControllerService
  ) {
    this.getUsuarios();
    icons.registerIcons([
      'filter',
      'filter-remove',
      'close',
      'chevron-double-left',
      'menu-up',
      'menu-down',
    ]);
  }

  private resizeHandler = () => {
    this.closeFilter();
  };

  ngOnInit(): void {
    if (!this.activeListener) {
      window.addEventListener('resize', this.resizeHandler);

      this.activeListener = true;
    }
  }

  async getUsuarios() {
    try {
      let usuarios: any;
      let usuariosInativos: any;

      if (this.apiUsuario?.listaUsuarios?.length) {
        usuarios = this.apiUsuario.listaUsuarios;
      } else {
        usuarios = await this.apiUsuario.buscaUsuarios();
      }

      let userSessao = this.apiUsuario.getCredenciais();

      let listaUsuarios = usuarios;

      usuarios = listaUsuarios.filter(
        (u) =>
          u.ativo == true &&
          u.confirmacao == false &&
          u.tipoRedefinicaoSenha != 'novo'
      );
      usuariosInativos = listaUsuarios.filter(
        (u) => u.ativo == false && u.confirmacao == false
      );
      usuariosInativos = usuariosInativos.slice(0, 5);

      for (let user of usuarios) {
        if (!this.apiUsuario.avatares[user.id]) {
          this.apiUsuario.avatares[user.id] = await this.getAvatarUsuario(
            user.id
          );
        }
        user['img'] = this.apiUsuario.avatares[user.id];

        if (userSessao && userSessao == user.id) {
          user['selectedDefault'] = true;
        }
      }

      this.listaUsuarios.ativos = usuarios;
      this.listaUsuarios.inativos = usuariosInativos;
    } catch (error) {
      console.log('Erro ao buscar usuários: ', error);
      window.location.reload();
    }
  }

  ngAfterViewInit() {
    this.verificaPermissoes();

    this.menusService.menuFilter().subscribe((ret) => {

      this.page = ret.page;
      this.data = ret?.data;
      this.filtersService = ret.filtersService;

      if (ret.open && ret.coords) {
        const menuPosition = this.triggerButton.nativeElement.style;
        menuPosition.left = `${ret.coords.x - 7}px`;
        menuPosition.top = `${ret.coords.y - 10}px`;

        this.initComponentPage();

        this.trigger.openMenu();
      }

      if (!ret.open) this.trigger.closeMenu();
    });
  }

  async initComponentPage() {
    this.container.clear();

    this.componentRef = this.container.createComponent(
      this.componentMap[this.page]
    );

    if (this.filtersService) {
      (this.componentRef as ComponentRef<unknown>).setInput('filtersService', this.filtersService);
    }

    const containerInstance: any = this.componentRef.instance;

    if (this.hasInput(containerInstance, 'listaUsuarios'))
      containerInstance.listaUsuarios = this.listaUsuarios;

    if (this.hasInput(containerInstance, 'showTodasCotacoes'))
      containerInstance.showTodasCotacoes = this.showTodasCotacoes;

    if (this.hasInput(containerInstance, 'gruposPermissoes'))
      containerInstance.gruposPermissoes = this.data;
  }

  private hasInput(instance: any, propName: string): boolean {
    const inputs = (instance.constructor as any).ɵcmp?.inputs || {};
    return Object.prototype.hasOwnProperty.call(inputs, propName);
  }

  async verificaPermissoes() {
    this.showTodasCotacoes =
      (await this.showIfAuthorizedDirective?.handleAuthorizationForComponent(
        'TODAS_COTACOES'
      )) ?? false;
    this.showTodasCotacoes = false;
  }

  async getAvatarUsuario(usuarioId) {
    try {
      let ret = await this.apiS3.getAvatarUsuario(usuarioId);
      return ret;
    } catch (error) {
      return '';
    }
  }

  closeFilter(clear = false) {
    this.menusService.open = false;
    this.menusService.setMenuFilter({ open: false, page: this.page });
    this.sendFilter(clear);
  }

  clearFilter() {
    this.numFilter = 0;
    this.componentRef?.instance?.clearFilter?.();

    this.closeFilter(true);
  }

  sendFilter(clear = false) {
    const filtro = this.componentRef?.instance?.buildString?.() ?? null;

    if(!filtro) return;

    let objEnvio = {
      page: this.page,
      filtro: filtro,
      clear: clear,
    };

    this.menusService.enviaFiltro(objEnvio);
  }

  ngOnDestroy(): void {
    this.menusService.open = false;
    this.menusService.setMenuFilter({ open: false, page: '' });

    if (this.activeListener) {
      window.removeEventListener('resize', this.resizeHandler);

      this.activeListener = false;
    }
  }
}
